let Service_URL = "";
//SERVICE_URL = (location.hostname + ':' + location.port);
let origin = location.origin;
if (!origin) {
  let port = location.port ? ':' + location.port : '';
  origin = location.protocol + "//" + location.hostname + port;
}
let path = location.href.split('/')[3];
if(path == '#'){
  path = '';
}

//Service_URL = origin + '/' + path;

Service_URL = '';
if(location.origin.includes('http://localhost')){
   Service_URL =  'https://localhost:4200/';  
}
else if(location.origin == 'https://dev.gatepass.deloitte.com'){
  Service_URL =  'https://dapi.gatepass.deloitte.com/'; 
}
else if(location.origin == 'https://qas.gatepass.deloitte.com'){
  Service_URL =  'https://qapi.gatepass.deloitte.com/'; 
}
else if(location.origin == 'https://stg.gatepass.deloitte.com'){
  Service_URL =  'https://sapi.gatepass.deloitte.com/'; 
}
else if(location.origin == 'https://stg.gpass.deloitte.com'){
  Service_URL =  'https://sapi.gpass.deloitte.com/'; 
}
else if(location.origin == 'https://gatepass.deloitte.com'){
  Service_URL =  'https://api.gatepass.deloitte.com/'; 
}
else if(location.origin == 'https://gpass.deloitte.com'){
  Service_URL =  'https://api.gpass.deloitte.com/'; 
}


//Service_URL = 'https://localhost:4200/';

export const ConstantsService : any = {
  'OfficeDetails': {
    GetAllOfficeDetailsByFilter: Service_URL + 'api/office/GetOfficeDetailsByFilter',
    DeleteOfficeId: Service_URL + 'api/office/deleteoffices',
    NewOffice: Service_URL + 'api/office/insertoffices',
    EditOffice: Service_URL + 'api/office/updateoffices',
    GetOffices: Service_URL + 'api/office/getoffices'
    },
  'OutwardDetails':{
    GetAllData: Service_URL+'api/outwardoperations/getoutwardoperations',
    GetPracticeData:Service_URL+'api/outwardmaster/getpracticemasterdata',
    GetRequestTypeData:Service_URL+'api/outwardmaster/gettransactionmasterdata',
    AddOutwardReq:Service_URL+'api/outwardoperations/insertoutwardrequest',
    EditOutwardReq:Service_URL+'api/outwardoperations/updateoutwardrequest',
    GetDataById:Service_URL+'api/outwardoperations/getoutwardoperationsbyid',
    GetOutwardRequestsByFilter:Service_URL+'api/outwardoperations/getoutwardrequestbyfilter',
    UpdateStatus : Service_URL + 'api/outwardoperations/updatestatus',
    DeleteRequest: Service_URL+'api/outwardoperations/deleteoutwardrequest',
    PrintPreview: Service_URL+'api/outwardoperations/getdocumentdata',
    GetOutwardDashboardData: Service_URL + 'api/outwardoperations/getoutwarddashboarddata',
    DeleteAttchedFile: Service_URL + 'api/outwardoperations/deleteattchedfile',
    Download: Service_URL + 'api/outwardoperations/downloadmaterialfilefroms3'
  },
  'CityDetails' : {
    GetAllCityDetailsByFilter:Service_URL+'api/city/GetAllCityDetailsByFilter',
    AddNewCity:Service_URL+'api/city/AddNewCity',
    EditCity:Service_URL+'api/city/UpdateCity',
    DeleteCityId: Service_URL + 'api/city/DeleteCity'
 },
  'Master':{
     officeMasterData: Service_URL+ 'api/master/getmasterdata',
     CityMasterData:Service_URL+'api/master/getCityMasterData',
     OutwardMasterData:Service_URL+'api/master/getoutwardmasterdata',
     InwardMasterData: Service_URL+'api/master/getinwardmasterdata'
  },
  'Users' : {

    getUser:Service_URL + 'api/users/getallusers',
    graphToken:Service_URL+'api/securedata/getgraphtoken',
    graphApi:Service_URL+'api/securedata/getrequestors',
    deleteUser:Service_URL+'api/users/delete',
    getMasterData : Service_URL+'api/users/getmasterdatausers',
    addUser : Service_URL+'api/users/create',
    getUserById : Service_URL + 'api/users/getuserbyid/',
    getUserDetailsByFilter:Service_URL + 'api/users/getuserdetailsbyfilter',
    updateUser : Service_URL + 'api/users/update',
    getuserbyemail: Service_URL + 'api/users/getuserbyemail/'
  },
  'InwardDetails' : {
    GetInwardRequests : Service_URL + 'api/inwardoperations/getinwardrequests',
    AddInwardRequest : Service_URL + 'api/inwardoperations/insertinwardrequest',
    UpdateInwardRequest : Service_URL + 'api/inwardoperations/updateinwardrequest',
    BroughtFrom : Service_URL + 'api/inwardmaster/getbroughtfrommaster',
    GetInwardRequestsByFilter : Service_URL + 'api/inwardoperations/getinwardrequestfilterdata',
    DeleteRequest : Service_URL + 'api/inwardoperations/deleteinwardrequest',
    ViewRequest : Service_URL + 'api/inwardoperations/getinwardrequestbyid',
    UpdateStatus : Service_URL + 'api/inwardoperations/updatestatus',
    UpdateReceivedBy : Service_URL + 'api/inwardoperations/updatereceivedby',
    GetInwardDashboardData: Service_URL + 'api/inwardoperations/getinwarddashboarddata',
    DeleteAttchedFile: Service_URL + 'api/inwardoperations/deleteattchedfile',
    Download: Service_URL + 'api/inwardoperations/downloadmaterialfilefroms3'
  },
  'OperationsMasterData' : {
    GetTransactionData : Service_URL + 'api/inwardmaster/gettransactionmasterdata'
  },
  'EmailConfiguration' : {
    getconfiguration:Service_URL + 'api/configuration/getconfiguration',
    Saveconfiguration:Service_URL + 'api/configuration/updateconfiguration' 

  },
  'AuditTrail': {
    saveconfigaudittrail: Service_URL + 'api/audittrail/saveconfigaudittrail',
    savetransactionaudittrail: Service_URL + 'api/audittrail/savetransactionaudittrail',
    GetAllAuditByFilter: Service_URL + 'api/AuditTrail/GetAllAuditByFilter',
    getconfigaudittrail:  Service_URL +'api/audittrail/getconfigaudittrail',
    exportauditdata: Service_URL + 'api/audittrail/exportconfigaudittrail',
    GetStatusHistory: Service_URL + 'api/audittrail/getstatushistory/{requestId}'
  },
  'CommonAuditTrail': {
    GetAllCommonAuditByFilter: Service_URL + 'api/CommonAuditTrail/GetAllCommonAuditByFilter',
    ExportCommonDataByFilter: Service_URL + 'api/CommonAuditTrail/ExportCommonDataByFilter'
  },
  'SignOut':{
    signOut : 'Account/SignOut',
    logOut :  location.origin+'/Account/SignOut'
  },
  'ChallanUpload':{
    upload: Service_URL + 'api/s3upload/uploadfiletos3',
    uploadpresigned: Service_URL + 'api/s3upload/uploadfiletos3bypresignedurl',
    download: Service_URL + 'api/s3upload/getdocumentfroms3'
  }
}

